'use client';

import React from 'react';

interface FilterBarProps {
  children?: React.ReactNode;
  filters?: Array<{
    type: 'search' | 'select';
    key: string;
    placeholder?: string;
    options?: string[];
    value: string;
    onChange: (value: string) => void;
  }>;
  extra?: React.ReactNode;
}

const FilterBar = React.memo(function FilterBar({ children, filters, extra }: FilterBarProps) {
  return (
    <div className="hrm-card p-4 hrm-animate-in hrm-delay-1">
      <div className="flex flex-col lg:flex-row gap-3 items-center">
        {filters?.map(f => (
          <div key={f.key} className={f.type === 'search' ? 'flex-1 w-full' : ''}>
            {f.type === 'search' ? (
              <div className="relative">
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-slate-400" />
                <input
                  type="text"
                  placeholder={f.placeholder}
                  value={f.value}
                  onChange={e => f.onChange(e.target.value)}
                  className="w-full pl-9 pr-4 py-2.5 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-sm text-slate-900 dark:text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-[var(--hrm-primary)]/50 transition-all"
                />
              </div>
            ) : (
              <select
                value={f.value}
                onChange={e => f.onChange(e.target.value)}
                className="w-full lg:w-auto px-4 py-2.5 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-sm text-slate-600 dark:text-slate-300 outline-none cursor-pointer focus:ring-2 focus:ring-[var(--hrm-primary)]/50"
              >
                <option value="">{f.placeholder || 'All'}</option>
                {f.options?.map(opt => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
            )}
          </div>
        ))}
        {extra}
        {children}
      </div>
    </div>
  );
});

export default FilterBar;
